import { useMemo } from 'react'
import { useDomainGoToPath } from './domain/routing'

/**
 * Provides a function to navigate the user to the store hours update history page.
 *
 * @param retailerLocationIds the (store / retailer location / warehouse locations) ids to be included on the page
 * (can be a single ID or an array of IDs)
 * @returns a function which, when invoked, navigates the user to the update history page
 */
export const useGoToUpdateHistory = (retailerLocationIds: string | string[]) => {
  const keysCommaSep = useMemo(() => {
    if (Array.isArray(retailerLocationIds)) {
      return retailerLocationIds.join(',')
    } else {
      return retailerLocationIds
    }
  }, [retailerLocationIds])

  const gotoUpdateHistoryPage = useDomainGoToPath(
    'store-hours-bulk-update-history',
    undefined,
    undefined,
    undefined,
    {
      storeIds: keysCommaSep,
    }
  )

  return gotoUpdateHistoryPage
}
